const ReportingPowerBIPage = () => import('./ReportingPowerBi.vue');

const routes = [
  {
    path: '/reporting-power-bi',
    name: 'ReportingPowerBIPage',
    id: 'reporting-power-bi',
    component: ReportingPowerBIPage,
    linkText: 'navBar.reportingPowerBi',
    meta: {
      featureKey: 'reportingPowerBIEnabled',
      titleExtension: 'navBar.reportingPowerBi',
      requiresPermission: false,
    },
    index: 3,
  },
];
export default routes;
